<template>
    <div class="base-activity" :class="{'activity-sp': $store.state.screen == 1}">
        <div v-if="isblank == true">
            <div class="list" v-for="(item, index) in list" :key="index" @click="$router.push('/base-activity-details?id=' + item.id)">
                <div class="left">
                    <div class="top">
                        <div v-for="(i, key) in config" :key="key">
                            <div class="mark" v-if="item.level == i.id">
                                <span>{{i.name}}</span>
                            </div>
                        </div>
                        <div class="title">{{item.title}}</div>
                    </div>
                    <div class="time">{{item.create_time | dateTime}}</div>
                </div>
                <img src="~images/move.png" />
            </div>
        </div>
        <div class="theblank" v-if="isblank == false">
            <TheBlank />
        </div>
        <div class="ddbottom" ref="bottomScroll"></div>
    </div>
</template>

<script>
    import moment   from 'moment'
    import TheBlank from '@/components/TheBlank'

    export default {
        components: {
            TheBlank
        },
        data () {
            return {
                list: [],
                accountData: {},
                mark: '',
                config: [],
                isblank: null
            }
        },
        filters: {
            dateTime (time) {
                return moment.unix(time).format('YYYY-MM-DD HH:mm')
            }
        },
        methods: {
            // 活动列表
            getList () {
                let options = {
                    appid: this.accountData.appid,
                    channel: this.accountData.channel
                }
                options.sign = this.util.getSign(options, this.accountData.appkey)
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=notice&a=getNoticeList', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.list = res.data.data.list
                        this.config = res.data.data.config
                        this.isblank = this.list.length > 0 ? true : false
                        sessionStorage.setItem('setActivity', JSON.stringify(res.data.data))
                    }
                })
            }
        },
        created () {
            this.accountData = JSON.parse(sessionStorage.getItem('accountData'))
            if (sessionStorage.getItem('setActivity')) {
                let setActivity = JSON.parse(sessionStorage.getItem('setActivity'))
                this.list = setActivity.list
                this.config = setActivity.config
                this.isblank = this.list.length > 0 ? true : false
            } else {
                this.getList()
            }
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-activity {
        margin-bottom: 60px;
        padding: 60px 60px 0;
        overflow: hidden;
        transition: all 0.3s;
        .list {
            height: 180px;
            border-radius: 18px;
            background: rgba(255, 255, 255, 0.2);
            padding: 0 45px;
            margin-bottom: 30px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .left {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .top {
                    display: flex;
                    align-items: center;
                }
                .mark {
                    min-width: 96px;
                    height: 45px;
                    font-size: 33px;
                    border-radius: 3px;
                    background: $color;
                    margin-right: 15px;
                    padding: 0 17px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .title {
                    max-width: 600px;
                    font-size: 45px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .time {
                    font-size: 36px;
                    color: rgba(255, 255, 255, 0.5);
                    margin-top: 15px;
                }
            }
            img {
                width: 36px;
                height: 36px;
            }
        }
        .list:last-child {
            margin-bottom: 0;
        }
        .theblank {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        .ddbottom {
            height: 90px;
            margin-bottom: -90px;
        }
    }
    // 竖屏css
    .activity-sp {
        margin-bottom: 90px;
        padding: 90px 90px 0;
        .list {
            height: 327px;
            border-radius: 32px;
            padding: 0 81px;
            margin-bottom: 54px;
            .left {
                .mark {
                    min-width: 174px;
                    height: 81px;
                    font-size: 60px;
                    border-radius: 5px;
                    margin-right: 27px;
                    padding: 0 30px;
                }
                .title {
                    max-width: 800px;
                    font-size: 81px;
                }
                .time {
                    font-size: 65px;
                    margin-top: 27px;
                }
            }
            img {
                width: 65px;
                height: 65px;
            }
        }
        .ddbottom {
            height: 163px;
            margin-bottom: -163px;
        }
    }
</style>